import { createFileRoute } from '@tanstack/react-router';

import { addTrackCrumb } from '../../../../error/tracking';

export const Route = createFileRoute('/app/funnel/$id/_layout-funnel/content')({
  beforeLoad: function () {
    addTrackCrumb({
      category: 'route',
      message: '/app/funnel/$id/_layout-funnel/content',
      level: 'info',
    });
    addTrackCrumb({
      category: 'funnel',
      message: 'entering funnel content',
      level: 'info',
    });
  },
  // eslint-disable-next-line no-use-before-define
  component: ContentRoute,
});

function ContentRoute() {
  // Note: this route exist only for loading purposes
  return <></>;
}
